import { render } from "./ITextarea.vue?vue&type=template&id=662b7bfc"
import script from "./ITextarea.vue?vue&type=script&lang=js"
export * from "./ITextarea.vue?vue&type=script&lang=js"

import "./ITextarea.vue?vue&type=style&index=0&id=662b7bfc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__